import axios from "axios";

const API_URL = process.env.REACT_APP_API_KEY;

const listarCidades = async (siglaEstado: string) => {
  const response = await axios.get(`${API_URL}/cidades/${siglaEstado}`);
  return response.data;
};
export default listarCidades;
